import { render } from "./aio-login-temporary-access.vue?vue&type=template&id=2b55b806&scoped=true"
import script from "./aio-login-temporary-access.vue?vue&type=script&lang=js"
export * from "./aio-login-temporary-access.vue?vue&type=script&lang=js"

import "./aio-login-temporary-access.vue?vue&type=style&index=0&id=2b55b806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b55b806"]])

export default __exports__